import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import Header from './components/Header';
import SignIn from './components/Main/SignIn';
import RecoverPassword from './components/Main/RecoverPassword';
import FormRecoverPassword from './components/Main/FormRecoverPassword';
import { SIGNIN, RECOVER_PASSWORD, NEW_PASSWORD ,HOME_ACCOUNT, LAWYERS_CONTACTED } from '../../routes';
import './index.scss';
import Home from '../LawyersContacted';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DashBoard from '../../layouts/Dashboard/'


const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    height: 88,
    maxWidth: 520,
    borderRadius: 4,
    margin: 'auto',
  },
  root: {
    flexGrow: 1,
    backgroundColor: '#f6f8fb',
    maxWidth: 980,
    margin: 'auto',
    marginBottom: 20,
  },
  tabStyle: {
    width: '50%',
    //maxWidth: 232,
    //minWidth: '20%',
    height: 66,
    //padding: '0 32px',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    '&$selected': {
      color: '#013957',
    },
    '@media screen and (max-width: 549px)': {
      minWidth: '100%',
    },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  tabs: {
    padding: '0 24px',
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    //width: 'fit-content',
    margin: 'auto',
  },
  scrollButtonsDesktop: {
    color: '#013957',
    display: 'none',
    '@media (max-width: 890px)': {
      display: 'inherit',
    },
    '&>svg': {
      fontSize: 24,
    },
  },
  panel: {
    position: 'relative',
    maxWidth: 980,
  },
  tabWrapper: {
    display: 'contents',
  },
}));

const SignInMain = ({ statusUser, history, user }) => {

  useEffect(() => {
    if(
      statusUser && statusUser === 2 &&
      user && user.roleAuth && user.roleAuth === 'lawyeruser'
    ) {
      history.push("/dashboard")
    }
  })

  return (  
  <div className="sign-container">
  <BrowserView>
    <div>
      <Header />
      <div className="container-general container-background">
          <Switch>
            <Route exact path={SIGNIN} component={SignIn} />
            <Route path={RECOVER_PASSWORD} component={RecoverPassword} />
          </Switch>
      </div>
    </div>
  </BrowserView>
  <MobileView>
    <div className="sign-in_center">
      <Switch>
        <Route path={LAWYERS_CONTACTED} component={Home} />
        <Route exact path={SIGNIN} component={SignIn} />
        <Route path={RECOVER_PASSWORD} component={RecoverPassword} />
      </Switch>
    </div>
  </MobileView>
</div>

);
}
const mapStateToProps = state =>({
  statusUser: state.userState.statusUser,
  user: state.userState.user,
})


export default connect(mapStateToProps)(withRouter(SignInMain))
